// Sliders: all Swiper instances + the scroll-driven customers carousel
export default function () {

    const $ = jQuery;

    const swiper_thumb = new Swiper(".wc__single-product-thumbnail-swiper", {
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            1024: {
                slidesPerView: 4,
            },
            0: {
                slidesPerView: 2.5,
            },
        },
    });

    const swiper_main = new Swiper('.wc__single-product-main-swiper', {
        slidesPerView: 1,
        spaceBetween: 12,
        navigation: {
            nextEl: ".wc__single-product-main-swiper-right",
            prevEl: ".wc__single-product-main-swiper-left",
        },
        thumbs: {
            swiper: swiper_thumb,
        },
    });

    const swiper1 = new Swiper('.customers-swiper', {
        spaceBetween: 64,
        centeredSlides: true,
        loop: true,
        allowTouchMove: false,
        speed: 1000,
        breakpoints: {
            1024: {
                slidesPerView: "auto",
            },
            0: {
                spaceBetween: 32,
                slidesPerView: 2.5,
            },
        },
    });

    const swiper2 = new Swiper('.customers-swiper-2', {
        spaceBetween: 64,
        loop: true,
        allowTouchMove: false,
        speed: 1000,
        breakpoints: {
            1024: {
                slidesPerView: "auto",
            },
            0: {
                spaceBetween: 32,
                slidesPerView: 2.5,
            },
        },
    });

    const swiper_carousel_products = new Swiper('.block__carousel-swiper', {
        spaceBetween: 12,
        breakpoints: {
            1024: {
                slidesPerView: 4,
            },
            0: {
                slidesPerView: 1.5,
            },
        },
    });

    const swiper_payment_methods = new Swiper('.wc__single-product-information-payments-swiper', {
        spaceBetween: 12,
        slidesPerView: 'auto',
    });

    const customersBlock = document.querySelector('.block__customers');

    if (customersBlock) {
        let lastProgress = 0;
        let lastIndex = -1;

        ScrollTrigger.create({
            trigger: customersBlock,
            start: 'top bottom',
            end: 'bottom top',
            scrub: false,
            onUpdate: (self) => {
                const progress = self.progress; // 0 to 1
                const direction = progress > lastProgress ? 'down' : 'up';
                const totalSteps = 10;
                const currentIndex = Math.floor(progress * totalSteps);

                if (currentIndex !== lastIndex) {
                    lastIndex = currentIndex;

                    if (direction === 'down') {
                        swiper1?.slideNext();
                        swiper2?.slidePrev();
                    } else {
                        swiper1?.slidePrev();
                        swiper2?.slideNext();
                    }
                }

                lastProgress = progress;
            }
        });
    }

}
